import { Typography } from 'material-ui'
import * as React from 'react'
import { SFC } from 'react'

export const
    AsideBox: SFC<{
        title: string | React.ReactNode
        linkText: string
        href: string
        greyBg?: boolean
    }> = ({title, linkText, href, greyBg, children}) => {
        const background = greyBg ? '#F7F7F7' : '#fff'
        return (
            <div style={{background, width: '100%'}}>
                <div style={{padding: 20}}>
                    <Typography type='title' style={{margin: '10px 0px', color: '#606060'}}>
                        {title}
                    </Typography>
                    <Typography
                        type='subheading'
                        style={{
                            margin: '10px 0px',
                            lineHeight: '2em',
                            color: '#aaa'
                        }}
                    >
                        {children}
                    </Typography>
                    <a href={href} target='_blank' style={{textDecoration: 'none'}}>
                        <Typography
                            type='title'
                            color='primary'
                            style={{
                                margin: '20px 0px',
                                fontSize: '1em'
                            }}
                        >
                            {linkText}
                        </Typography>
                    </a>
                </div>
            </div>
        )
    }



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/stories/AsideBox.tsx